<template>
    <div class="side-menu-picture">
        <img :src="src" alt="Side Menu Picture" class="sidebar-pic" data-test-id="sidebar-pic" />
    </div>
</template>

<script>
export default {
    props: {
        src: {
            type: String,
            required: true,
        },
    },
    // A `data` property is needed so that this file is taken into account by jest's code coverage
    // (cf. https://github.com/vuejs/vue-jest/issues/32)
    //
    data() {
        return {};
    },
};
</script>

<style scoped>
.side-menu-picture {
    margin-bottom: 30px;
}
</style>
